"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _media = require("../actions/media");

const medias = function medias() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.fromJS)({});
  let action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _media.ADD_ASSETS:
      {
        const payload = action.payload;
        let newState = state;
        payload.forEach(asset => {
          newState = newState.set(asset.path, asset);
        });
        return newState;
      }

    case _media.ADD_ASSET:
      {
        const payload = action.payload;
        return state.set(payload.path, payload);
      }

    case _media.REMOVE_ASSET:
      {
        const payload = action.payload;
        return state.delete(payload);
      }

    default:
      return state;
  }
};

var _default = medias;
exports.default = _default;